module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig02_pitch-deviations.eaa55e8f.png";